import React from 'react';

import Button from '../Button';
import { UserInfo } from '../index';
import { maskPhoneNumber } from '../../util';

import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface props {
  userInfo: UserInfo;
  onClickEditingButton(): void;
}

const UserInfoContent: React.FC<props> = (props) => {
  const { userInfo, onClickEditingButton } = props;
  const phone = maskPhoneNumber(userInfo.phoneNumber);
  const { t } = useTranslation();

  const info = userInfo.name ? (
    <>
      <p className={styles.highlight}>{userInfo.name}</p>
      <p className={styles.phone}>{phone}</p>
    </>
  ) : (
    <p className={styles.highlight}>{phone}</p>
  );

  return (
    <div className={styles.userInfo}>
      <div className={styles.userDescription}>{info}</div>
      <Button data-id="btn_edit_my_info" onClick={onClickEditingButton}>
        {t('내 정보 관리')}
      </Button>
    </div>
  );
};

export default UserInfoContent;
